import { Button } from '@backstage/ui';
import { Icon } from '@iconify/react';
import { DataProductEntityFilter } from '@ipen-portal/ipen-entity-model';
import { useGetEntitiesByFilter } from '@ipen-portal/plugin-common-react';
import { useNavigate } from 'react-router';

import { useShuffledEntities } from '../../hooks/useShuffledEntities';
import { HomeEntityCard } from './components/HomeEntityCard';
import classes from './DataProductsHomeCard.module.css';

export const DataProductsHomeCard = () => {
  const { data, isError, isPending } = useGetEntitiesByFilter(
    DataProductEntityFilter,
  );
  const dataProducts = useShuffledEntities(data);
  const navigate = useNavigate();
  const message = isError ? 'Data Products could not be loaded' : undefined;

  return (
    <HomeEntityCard
      aria-label="Data Products"
      className={classes.root}
      entities={dataProducts}
      footerAction={(
        <Button
          aria-label="Go to Data Products Catalog"
          className={classes.explore}
          onPress={() => navigate('/catalog?filters[kind]=Component&filters[type]=data-product')}
          variant="secondary"
        >
          <Icon aria-hidden="true" icon="ri:arrow-right-s-line" />
          Go to Data Products Catalog
        </Button>
      )}
      loading={isPending}
      message={message}
      showImages={false}
      title="Discover Data Products"
    />
  );
};
